import { toFolder } from '../mappers/folder';
export function parseFolders(res) {
  const {
    nextPageToken,
    albums
  } = res.data;
  const paging = {
    cursor: nextPageToken
  };
  return {
    data: (albums || []).map(toFolder),
    paging
  };
}